import React from 'react';
import { Link } from 'react-router-dom';
import { ILinkText } from './types.type';

export const LinkText = ({ to, text, linkText }: ILinkText) => (
  <div className="text-center w-[325px] mx-auto">
    <div className="flex flex-col md:flex-row md:justify-center gap-[10px] text-gray-900 font-body text-[16px] font-medium">
      <span>{text}</span>
      <Link
        to={to}
        className="text-base-black font-body text-[16px] font-medium hover:text-blue-500 active:text-blue-600"
      >
        {linkText}
      </Link>
    </div>
  </div>
);
